import React, { useEffect, useState } from "react";
import { FaRecycle } from "react-icons/fa6";
import { IconButton, Popover } from "@mui/material";
import { IoIosWarning } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import VehicleTypeChart from "./VehicleTypeChart";
import { IoIosInformationCircle } from "react-icons/io";
import { FaCar } from "react-icons/fa";
import { SiVirustotal } from "react-icons/si";
import { getServiceCenterOptionApi } from "../../../services/SearchService";
import { toast } from "react-toastify";
import { MdOutlineAssessment } from "react-icons/md";
import DatePicker from "react-datepicker";
import {
  getCashDashboardApi,
  getPaymentMethodDashboardApi,
  getThisMonthBillingDashboardApi,
  getThisMonthExpenseDashboardApi,
  getTodayBillibgDashboardApi,
} from "../../../services/DashboardService";
import {
  formatToIndianNumber,
  paymentStatusBadge,
  useIsMobile,
} from "../../../utilities";
import { format } from "date-fns";
import ProfitLossCard from "./MonthlySmallProfitLosscard";
import ProfitLossLineChart from "./ProfitLossLineChart";
import { CustomTooltip } from "../../../components/CustomTooltip";
import ServiceTypeChart from "./ServiceTypeChart";
import TimeChart from "./TimeChart";
import { FiUser } from "react-icons/fi";
import { FiCreditCard } from "react-icons/fi";
import { MdQrCodeScanner } from "react-icons/md";
import { BsCashCoin } from "react-icons/bs";
import { TbSum } from "react-icons/tb";
const getPaymentIcon = (method) => {
  switch (method?.toLowerCase()) {
    case "upi business":
      return <MdQrCodeScanner className="me-1 text-primary" size={16} />;
    case "upi personal":
      return <MdQrCodeScanner className="me-1 text-success" size={16} />;
    case "cash":
      return <BsCashCoin className="me-1 text-warning" size={16} />;
    case "card":
      return <FiCreditCard className="me-1 text-info" size={16} />;
    default:
      return <FiCreditCard className="me-1 text-muted" size={16} />;
  }
};
const AdminDashboard = () => {
  const isMobile = useIsMobile();

  const [paymentMethodParam, setPaymentMethodParam] = useState({
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  });
  //payment method
  const [paymntmethod, setPaymentMethod] = useState(null);
  //total cash,petty cash
  const [cashSummary, setCashSummary] = useState(null);
  //today expense
  const [billSummary, setBillSummary] = useState({
    total_amount: 0,
    paid_amount: 0,
    unpaid_amount: 0,
    partial_paid_amount: 0,
    paid_count: 0,
    unpaid_count: 0,
    total_count: 0,
    partial_paid_count: 0,
  });

  //this-month expense summary
  const [thisMonthExpenseSummary, setThisMonthExpenseSummary] = useState({
    total_amount: 0,
    paid_amount: 0,
    unpaid_amount: 0,
    partial_paid_amount: 0,
    total_count: 0,
    paid_count: 0,
    unpaid_count: 0,
    partial_paid_count: 0,
    last_month_amount: 0,
  });

  //last 10 expense
  const [lastTenExpenses, setLastTenExpenses] = useState([]);
  //last-month-bill summary
  const [thisMonthBillSummary, setThisMonthBillSummary] = useState({
    free_service_amount: 0,
    total_amount: 0,
    paid_amount: 0,
    unpaid_amount: 0,
    partial_paid_amount: 0,
    discount_amount: 0,
    tips_amount: 0,
    total_count: 0,
    paid_count: 0,
    unpaid_count: 0,
    partial_paid_count: 0,
    discount_count: 0,
    tips_count: 0,
    free_service_count: 0,
    last_month_amount: 0,
  });
  //servicecenter-option
  const [serviceCenterOption, setServiceCenterOption] = useState([]);
  const [selectedServicecenter, setSelectedServiceCenter] = useState();

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const getServiceCenter = () => {
    getServiceCenterOptionApi()
      .then((res) => {
        const option =
          res?.data?.results?.map((item) => ({
            ...item,
            icons: <FaCar className="me-1" />,
          })) || [];
        setServiceCenterOption([
          {
            label: "All",
            value: "all",
            icons: <SiVirustotal className="me-1" />,
            prefix: "All",
          },
          ...option,
        ]);
        setSelectedServiceCenter("all");
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getTodayBillingApi = () => {
    getTodayBillibgDashboardApi(
      selectedServicecenter == "all" ? "" : selectedServicecenter
    )
      .then((res) => {
        const data = res?.data?.results?.overall_summary;
        setBillSummary({
          total_amount: data?.total_amount || 0,
          paid_amount: data?.payment_received || 0,
          unpaid_amount: data?.total_outstanding || 0,
          partial_paid_amount: data?.partially_paid_amount || 0,
          paid_count: data?.paid_count || 0,
          unpaid_count: data?.unpaid_count || 0,
          total_count: data?.total_billings || 0,
          partial_paid_count: data?.partially_paid_count || 0,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getThisMonthBilling = () => {
    getThisMonthBillingDashboardApi(
      selectedServicecenter == "all" ? "" : selectedServicecenter
    )
      .then((res) => {
        const data = res?.data?.results?.overall_summary;
        setThisMonthBillSummary({
          total_amount: data?.total_amount || 0,
          paid_amount: data?.payment_received || 0,
          unpaid_amount: data?.total_outstanding || 0,
          partial_paid_amount: data?.partial_paid_amount || 0,
          discount_amount: data?.total_discount || 0,
          tips_amount: data?.total_tips || 0,
          free_service_amount: data?.free_service_value || 0,
          free_service_count: data?.free_service_count || 0,
          total_count: data?.total_billings || 0,
          paid_count: data?.payment_received_count || 0,
          partial_paid_count: data?.partially_paid_count || 0,
          unpaid_count: data?.outstanding_count || 0,
          discount_count: data?.discount_count || 0,
          tips_count: data?.tips_count || 0,
          last_month_amount:res?.data?.results?.comparison_data?.last_month_total || 0,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getThisMonthExpense = () => {
    getThisMonthExpenseDashboardApi(
      selectedServicecenter == "all" ? "" : selectedServicecenter
    )
      .then((res) => {
        const expense = res?.data?.results?.summary;
        setThisMonthExpenseSummary({
          total_amount: expense?.total_expenses || 0,
          paid_amount: expense?.paid_amount || 0,
          unpaid_amount: expense?.unpaid_amount || 0,
          partial_paid_amount: expense?.partial_paid_amount || 0,
          total_count: expense?.total_count || 0,
          paid_count: expense?.paid_count || 0,
          unpaid_count: expense?.unpaid_count || 0,
          partial_paid_count: expense?.partial_count || 0,
          last_month_amount: res?.data?.results?.last_month_total_expenses || 0,
        });
        setLastTenExpenses(res?.data?.results?.last_10_expenses || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getPaymentMethod = () => {
    getPaymentMethodDashboardApi(
      selectedServicecenter == "all" ? "" : selectedServicecenter,
      paymentMethodParam
    )
      .then((res) => {
        setPaymentMethod(res?.data);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getCash = () => {
    getCashDashboardApi(
      selectedServicecenter == "all" ? "" : selectedServicecenter
    )
      .then((res) => {
        const data = res?.data?.results || {};
        setCashSummary(data);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    getServiceCenter();
  }, []);
  useEffect(() => {
    if (selectedServicecenter) {
      getThisMonthBilling();
      getThisMonthExpense();
      getTodayBillingApi();
      getCash();
    }
  }, [selectedServicecenter]);
  useEffect(() => {
    if (selectedServicecenter) {
      getPaymentMethod();
    }
  }, [selectedServicecenter, paymentMethodParam]);

  return (
    <div className="container-fluid p-0">
      <div className="mb-3 d-flex justify-content-between">
        <ul
          className="nav flex-row custom-nav2 shadow-sm"
          style={{
            backgroundColor: "rgba(255,255,255) !important",
            backdropFilter: "blur(4px)",
            border: "1px solid #d6d1d1",
            padding: "0.35rem",
          }}
        >
          {serviceCenterOption.map((tab) => (
            <li className="nav-item" key={tab?.label}>
              <span
                className={`cursor-pointer nav-link ${
                  selectedServicecenter == tab.value ? "active" : ""
                }`}
                style={{ fontSize: "0.75rem" }}
                onClick={() => setSelectedServiceCenter(tab?.value)}
              >
                {tab?.icons}
                <CustomTooltip title={tab?.label}>
                  <span>
                    {tab?.label?.length > 8
                      ? tab?.label.split(" ").slice(-1)[0] + "..."
                      : tab?.label}
                  </span>
                </CustomTooltip>
              </span>
            </li>
          ))}
        </ul>
      </div>
      <div className={`row ${isMobile ? "g-1" : "g-3"}`}>
        <div className="col-3">
          <div
            className={`card shadow-sm overflow-hidden h-100 ${
              isMobile ? "rounded-2" : "rounded-4"
            }`}
            style={{
              background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-15%",
                right: "-15%",
                width: "140px",
                height: "140px",
                background:
                  "linear-gradient(135deg, rgba(234, 179, 8, 0.15), rgba(254, 243, 199, 0.1))",
                borderRadius: "50%",
                filter: "blur(50px)",
                opacity: "0.7",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: "-20%",
                left: "-20%",
                width: "120px",
                height: "120px",
                background:
                  "linear-gradient(135deg, rgba(234, 179, 8, 0.12), rgba(254, 243, 199, 0.08))",
                borderRadius: "50%",
                filter: "blur(40px)",
                opacity: "0.5",
                pointerEvents: "none",
              }}
            ></div>

            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "4px",
                background: "linear-gradient(90deg, #eab308, #fde047)",
                borderRadius: "4px 4px 0 0",
              }}
            ></div>

            <div
              className={`card-body position-relative d-flex align-items-center justify-content-between ${
                isMobile ? "p-2" : "p-4"
              }`}
            >
              <div className="text-center flex-fill">
                <h5
                  className="fw-bold mb-1"
                  style={{
                    fontSize: isMobile ? "0.5rem" : "1.16rem",
                    color: "#713f12",
                  }}
                >
                  ₹{formatToIndianNumber(cashSummary?.total_cash)}
                </h5>
                <p
                  className="fw-medium mb-0"
                  style={{
                    fontSize: isMobile ? "0.36rem" : "0.85rem",
                    lineHeight: "1.4",
                  }}
                >
                  Total Cash
                </p>
              </div>

              <div className="text-center flex-fill border-start">
                <h5
                  className="fw-bold mb-1"
                  style={{
                    fontSize: isMobile ? "0.5rem" : "1.16rem",
                    color: "#713f12",
                  }}
                >
                  ₹{formatToIndianNumber(cashSummary?.total_petty_cash)}
                </h5>
                <p
                  className="fw-medium mb-0"
                  style={{
                    fontSize: isMobile ? "0.36rem" : "0.85rem",
                  }}
                >
                  Petty Cash
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-3">
          <div
            className={`card shadow-sm overflow-hidden h-100 ${
              isMobile ? "rounded-2" : "rounded-4"
            }`}
            style={{
              background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
            }}
          >
            {/* Decorative Gradient Orbs */}
            <div
              style={{
                position: "absolute",
                top: "-15%",
                right: "-15%",
                width: "140px",
                height: "140px",
                background:
                  "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(147, 197, 253, 0.1))",
                borderRadius: "50%",
                filter: "blur(50px)",
                opacity: "0.7",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: "-20%",
                left: "-20%",
                width: "120px",
                height: "120px",
                background:
                  "linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(147, 197, 253, 0.08))",
                borderRadius: "50%",
                filter: "blur(40px)",
                opacity: "0.5",
                pointerEvents: "none",
              }}
            ></div>

            {/* Subtle Border Accent */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "4px",
                background: "linear-gradient(90deg, #3b82f6, #60a5fa)",
                borderRadius: "4px 4px 0 0",
              }}
            ></div>

            <div
              className={`card-body d-flex align-items-center justify-content-between position-relative ${
                isMobile ? "p-2" : "p-4"
              }`}
            >
              {/* Left Section: Value and Label */}
              <div className="d-flex flex-column">
                <h4
                  className="mb-1 fw-bold"
                  style={{
                    fontSize: isMobile ? "0.8rem" : "1.25rem",
                    color: "#1e3a8a",
                    letterSpacing: "-0.025em",
                  }}
                >
                  ₹{formatToIndianNumber(billSummary?.total_amount || 0)}
                </h4>
                <p
                  className="mb-0 fw-medium"
                  style={{
                    fontSize: isMobile ? "0.53rem" : "0.85rem",
                    lineHeight: "1.4",
                  }}
                >
                  Sell Amount (
                  {formatToIndianNumber(billSummary?.total_count || 0)})
                </p>
              </div>

              {/* Right Section: Icon with Gradient Background */}
              <div
                className="d-none d-md-flex align-items-center justify-content-center rounded-circle"
                style={{
                  padding: "0.75rem",
                  background: "linear-gradient(135deg, #3b82f6, #60a5fa)",
                  color: "white",
                  boxShadow: "0 6px 15px rgba(59, 130, 246, 0.3)",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <MdOutlineAssessment size={25} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-3">
          <div
            className={`card shadow-sm overflow-hidden h-100 ${
              isMobile ? "rounded-2" : "rounded-4"
            }`}
            style={{
              background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
            }}
          >
            {/* Decorative Gradient Orbs */}
            <div
              style={{
                position: "absolute",
                top: "-15%",
                right: "-15%",
                width: "140px",
                height: "140px",
                background:
                  "linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(187, 247, 208, 0.1))",
                borderRadius: "50%",
                filter: "blur(50px)",
                opacity: "0.7",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: "-20%",
                left: "-20%",
                width: "120px",
                height: "120px",
                background:
                  "linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(187, 247, 208, 0.08))",
                borderRadius: "50%",
                filter: "blur(40px)",
                opacity: "0.5",
                pointerEvents: "none",
              }}
            ></div>
            {/* Border Accent */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "4px",
                background: "linear-gradient(90deg, #22c55e, #86efac)",
                borderRadius: "4px 4px 0 0",
              }}
            ></div>
            <div
              className={`card-body d-flex align-items-center justify-content-between position-relative ${
                isMobile ? "p-2" : "p-4"
              }`}
            >
              <div className="d-flex flex-column">
                <h4
                  className="mb-1 fw-bold"
                  style={{
                    fontSize: isMobile ? "0.8rem" : "1.25rem",
                    // color: "#1e3a8a",
                    color: "#14532d",
                    letterSpacing: "-0.025em",
                  }}
                >
                  ₹{formatToIndianNumber(billSummary?.paid_amount || 0)}
                </h4>
                <p
                  className="mb-0 text-gray-600 fw-medium"
                  style={{
                    fontSize: isMobile ? "0.6rem" : "0.85rem",
                    lineHeight: "1.4",
                  }}
                >
                  Paid ({billSummary?.paid_count || 0})
                </p>
              </div>
              <div
                className="d-none d-md-flex align-items-center justify-content-center rounded-circle"
                style={{
                  padding: "0.75rem",
                  background: "linear-gradient(135deg, #22c55e, #86efac)",
                  color: "white",
                  boxShadow: "0 6px 15px rgba(34, 197, 94, 0.3)",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <FaCheckCircle size={25} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-3">
          <div
            className={`card shadow-sm overflow-hidden h-100 ${
              isMobile ? "rounded-2" : "rounded-4"
            }`}
            style={{
              background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
            }}
          >
            {/* Decorative Gradient Orbs */}
            <div
              style={{
                position: "absolute",
                top: "-15%",
                right: "-15%",
                width: "140px",
                height: "140px",
                background:
                  "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(254, 202, 202, 0.1))",
                borderRadius: "50%",
                filter: "blur(50px)",
                opacity: "0.7",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: "-20%",
                left: "-20%",
                width: "120px",
                height: "120px",
                background:
                  "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(254, 202, 202, 0.08))",
                borderRadius: "50%",
                filter: "blur(40px)",
                opacity: "0.5",
                pointerEvents: "none",
              }}
            ></div>
            {/* Border Accent */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "4px",
                background: "linear-gradient(90deg, #ef4444, #f87171)",
                borderRadius: "4px 4px 0 0",
              }}
            ></div>
            <div
              className={`card-body d-flex align-items-center justify-content-between position-relative ${
                isMobile ? "p-2" : "p-4"
              }`}
            >
              <div className="d-flex flex-column">
                <h4
                  className="mb-1 fw-bold text-primary"
                  style={{
                    fontSize: isMobile ? "0.8rem" : "1.25rem",
                    // color: "#1e3a8a",
                    letterSpacing: "-0.025em",
                  }}
                >
                  ₹{formatToIndianNumber(billSummary?.partial_paid_amount || 0)}
                </h4>
                <p
                  className="mb-0 fw-medium"
                  style={{
                    fontSize: isMobile ? "0.55rem" : "0.85rem",
                    lineHeight: "1.4",
                  }}
                >
                  Partially Paid ({billSummary?.partial_paid_count || 0})
                </p>
              </div>
              <div
                className="d-none d-md-flex align-items-center justify-content-center rounded-circle"
                style={{
                  padding: "0.75rem",
                  background: "linear-gradient(135deg, #ef4444, #f87171)",
                  color: "white",
                  boxShadow: "0 6px 15px rgba(239, 68, 68, 0.3)",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <FaRecycle size={25} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-md-4">
          <TimeChart selectedServicecenter={selectedServicecenter} />
        </div>
        <div className="col-md-4">
          <div className="card p-2 border-0 rounded-3 shadow-sm h-100">
            <div className="mb-3 d-flex justify-content-between gap-1 align-items-center">
              <h5 className="mb-0">Payment Method</h5>
              <div className="">
                <style>
                  {`
      .react-datepicker__input-container input {
        font-size: 0.65rem !important;
        height:31px !important;
      }
           .react-datepicker__close-icon::after {
        font-size: 9px !important;
        line-height: 9px !important;
        width: 13px !important;
        height: 9px !important;
      }
    `}
                </style>
                <DatePicker
                  selectsRange
                  startDate={
                    paymentMethodParam?.start_date
                      ? new Date(paymentMethodParam.start_date)
                      : null
                  }
                  endDate={
                    paymentMethodParam?.end_date
                      ? new Date(paymentMethodParam.end_date)
                      : null
                  }
                  onChange={(update) => {
                    const [start, end] = update;
                    setPaymentMethodParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                />
              </div>
            </div>
            <div
              className="d-flex align-items-center mb-4"
              style={{ fontSize: "0.9rem" }}
            >
              <div
                className="d-flex align-items-center"
                style={{ minWidth: "65px" }}
              >
                <TbSum className="me-1 text-darker" size="16" />
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.85rem" }}
                >
                  Total
                </span>
              </div>

              <div className="flex-grow-1 mx-2">
                <div
                  className="progress"
                  style={{ height: "6.5px", backgroundColor: "#f1f3f5" }}
                >
                  <div
                    className="progress-bar"
                    style={{
                      width: "100%",
                      backgroundColor: "#fb807d",
                    }}
                  />
                </div>
              </div>

              <div style={{ minWidth: "30px", textAlign: "right" }}>
                <span className="fw-medium text-darker">
                  ₹{formatToIndianNumber(paymntmethod?.total || 0)}
                </span>
              </div>
            </div>
            {paymntmethod?.results.map((item, idx) => {
              const percentage =
                Number(paymntmethod?.total) > 0
                  ? (Number(item?.total_amount) / Number(paymntmethod.total)) *
                    100
                  : 0;

              return (
                <div
                  key={idx}
                  className="d-flex align-items-center mb-4"
                  style={{ fontSize: "0.9rem" }}
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ minWidth: "65px" }}
                  >
                    {getPaymentIcon(item?.payment_method)}
                    <span
                      className="text-darker fw-medium"
                      style={{ fontSize: "0.85rem" }}
                    >
                      {item?.payment_method?.toLowerCase() == "upi business"
                        ? "UPI B"
                        : item?.payment_method?.toLowerCase() == "upi personal"
                        ? "UPI P"
                        : item?.payment_method || ""}
                    </span>
                  </div>

                  <div className="flex-grow-1 mx-2">
                    <div
                      className="progress"
                      style={{ height: "6.5px", backgroundColor: "#f1f3f5" }}
                    >
                      <div
                        className="progress-bar"
                        style={{
                          width: `${percentage}%`,
                          backgroundColor: "#fb807d",
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ minWidth: "30px", textAlign: "right" }}>
                    <span className="fw-medium text-darker">
                      ₹{formatToIndianNumber(item?.total_amount || 0)}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="col-md-4">
          <ServiceTypeChart selectedServicecenter={selectedServicecenter} />
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-md-4">
          <div className="card p-2 border-0 rounded-3 shadow-sm h-100">
            <div className="mb-2">
              <h5>This Month Expense Summary</h5>
            </div>
            <div className="d-flex flex-column gap-1">
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Total Amount:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthExpenseSummary?.total_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-info-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthExpenseSummary?.total_count || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Paid:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthExpenseSummary?.paid_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-success-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthExpenseSummary?.paid_count || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Unpaid:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthExpenseSummary?.unpaid_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-danger-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthExpenseSummary?.unpaid_count || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Partially Paid:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthExpenseSummary?.partial_paid_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-warning-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthExpenseSummary?.partial_paid_count || 0}
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-between gap-1 align-items-center mt-4 border-top pt-3">
              <h6 className="mb-0" style={{ fontSize: "0.85rem" }}>
                Last 10 Expenses
              </h6>
              <IconButton
                onClick={handleClick}
                size="small"
                style={{
                  border: "1px solid #ddd",
                  padding: "2px 6px",
                  borderRadius: "6px",
                }}
              >
                <IoIosInformationCircle className="text-dark me-1" size={12} />
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.65rem" }}
                >
                  View
                </span>
              </IconButton>
            </div>
            <div className="mt-2">
              <ProfitLossCard
                currentMonth={thisMonthExpenseSummary?.total_amount}
                previousMonth={thisMonthExpenseSummary?.last_month_amount}
                isExpense
              />
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card p-2 shadow-sm rounded-3 border-0">
            <div className="mb-2">
              <h5>This Month Billing Summary</h5>
            </div>
            <div className="d-flex flex-column gap-1">
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Free Service:</span>
                  <span className="text-darker">
                    {thisMonthBillSummary?.free_service_count || 0}
                  </span>
                </div>
                <span className="text-danger">
                  ₹
                  {formatToIndianNumber(
                    thisMonthBillSummary?.free_service_amount || 0
                  )}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Total Amount:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthBillSummary?.total_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-info-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthBillSummary?.total_count || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Paid:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthBillSummary?.paid_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-success-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthBillSummary?.paid_count || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Outstanding:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthBillSummary?.unpaid_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-danger-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthBillSummary?.unpaid_count || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Partially Paid:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthBillSummary?.partial_paid_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-warning-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthBillSummary?.partial_paid_count || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Discount:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthBillSummary?.discount_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-danger-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthBillSummary?.discount_count || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex gap-1 fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  <span className="text-dark">Tips:</span>
                  <span className="text-darker">
                    ₹
                    {formatToIndianNumber(
                      thisMonthBillSummary?.tips_amount || 0
                    )}
                  </span>
                </div>
                <span
                  className="text-bg-info-soft rounded-2"
                  style={{ fontSize: "0.7rem", padding: "0.2rem 0.4rem" }}
                >
                  {thisMonthBillSummary?.tips_count || 0}
                </span>
              </div>
            </div>
            {
              <ProfitLossCard
                currentMonth={thisMonthBillSummary?.total_amount}
                previousMonth={thisMonthBillSummary?.last_month_amount}
              />
            }
          </div>
        </div>
        <div className="col-md-4">
          <VehicleTypeChart selectedServicecenter={selectedServicecenter} />
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-12">
          <ProfitLossLineChart selectedServicecenter={selectedServicecenter} />
        </div>
      </div>
      <Popover
        className="scroll-container"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            p: 1,
            boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
            borderRadius: "8px",
            width: {
              xs: "90vw",
            },
            minWidth: { sm: "300px" },
            maxWidth: { sm: "400px" },
          },
        }}
      >
        <div className="d-flex justify-content-between gap-2 p-1">
          <h6>Expense Details</h6>
          <span className="text-dark fw-medium" style={{ fontSize: "0.7rem" }}>
            (Last 10 Expenses)
          </span>
        </div>
        <div
          className="scroll-container"
          style={{ overflowY: "scroll", maxHeight: "280px" }}
        >
          <div className="table-responsive">
            <table className="table table-sm table-borderless fs-6 mb-0 align-middle">
              <thead className="custom-thead">
                <tr>
                  <th>Date</th>
                  <th>Amount</th>
                  <th className="text-end">Paid Amount</th>
                  <th className="text-end">Status</th>
                </tr>
              </thead>
              <tbody>
                {lastTenExpenses.map((exp, index) => (
                  <tr key={index}>
                    <td>
                      {exp?.date
                        ? format(new Date(exp?.date), "dd MMM yyy")
                        : ""}
                    </td>
                    <td>{formatToIndianNumber(exp?.amount || 0)}</td>
                    <td className="text-end">
                      ₹{formatToIndianNumber(exp?.paid_amount || 0)}
                    </td>
                    <td className="text-end">
                      {paymentStatusBadge(exp?.payment_status)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default AdminDashboard;
